import { Form, Input, Modal, Space } from 'antd'
import { useTranslation } from 'react-i18next'

const { TextArea } = Input

const ActionConfirmModal = ({ visible, onClose, onConfirm, isSaving, dataRow, usersList }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const ADJUSTMENTS_TYPE = {
    EXPANSION: 'LABEL_EXPANSION',
    REDUCTION: 'LABEL_REDUCTION',
    RECLASSIFICATION: 'LABEL_RECLASSIFICATION',
  }

  const handleOk = () => {
    const comment = form.getFieldValue('comment')
    onConfirm(comment)
  }

  const handleClose = () => {
    form.resetFields()
    onClose()
  }

  return (
    <Modal
      title={t('PLANNING_SAC_ACTION_CONFIRM_MODAL_TITLE')}
      visible={visible}
      onCancel={handleClose}
      okText={t('ACTION_CONFIRM')}
      onOk={handleOk}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ disabled: isSaving }}
      afterClose={() => form.resetFields()}
      centered
      destroyOnClose
      forceRender
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {t('PLANNING_SAC_ACTION_CONFIRM_MODAL_BODY_TEXT', {
          adjustmentType: t(ADJUSTMENTS_TYPE[dataRow.adjustment_type]),
          userName: usersList.values.find((el) => el.id === dataRow.user)?.full_name,
          amount: dataRow.total_amount,
        })}
        <Form form={form} layout="vertical">
          <Form.Item name="comment" label={t('FIELD_COMMENT')} style={{ marginBottom: 0 }}>
            <TextArea rows={3} maxLength={500} disabled={isSaving} />
          </Form.Item>
        </Form>
      </Space>
    </Modal>
  )
}

export default ActionConfirmModal
